"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgParticleSizeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.particle-size_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "particle-size_outline_svg__transparent_box" },
            React.createElement("path", { className: "particle-size_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "particle-size_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "particle-size_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M21.58 5.18L18.4 2h-6.76L6 6.52v7.89l4.48 4.48 7.71 2.2L26 15.51V7.38zM24 14.49l-6.2 4.42-6.29-1.8L8 13.59V7.48L12.34 4h5.23l2.83 2.82 3.6 1.8zM23.99 25h-16v-3h-2v8h2v-3h4v2h2v-2h4v2h2v-2h4v3h2v-8h-2v3z" }))));
}
exports.default = SvgParticleSizeOutline;
//# sourceMappingURL=ParticleSizeOutline.js.map